import { LOCALE_ID, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideTransloco, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoModule } from '@ngneat/transloco';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomepageComponent } from './components/core/Stock Manager/homepage/homepage.component';
import { LoginComponent } from './components/Authentication/login/login.component';
import { AdditemComponent } from './components/core/Stock Manager/additem/additem.component';
import { ProfileComponent } from './components/core/user manager/profile/profile.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { HeaderComponent } from './shared/header/header.component';
import { HeaderMobileComponent } from './shared/header.mobile/header.mobile.component';
import { FooterComponent } from './shared/footer/footer.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { LanguageServiceService } from './services/language-service.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { BaseChartDirective } from 'ng2-charts';
import { LoadingComponent } from './shared/loading/loading.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { InvoiceComponent } from './components/core/orders manager/invoice/invoice.component';
import { NodataComponent } from './shared/nodata/nodata.component';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// or
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ChangePasswordComponent } from './components/Authentication/change-password/change-password.component';
import { MatTableModule } from '@angular/material/table';
import { AllusersComponent } from './components/core/user manager/allusers/allusers.component';
import { AddorderComponent } from './components/core/orders manager/addorder/addorder.component';
import { OrderspageComponent } from './components/core/orders manager/orderspage/orderspage.component';
import { WelcomeComponent } from './components/core/static pages/welcome/welcome.component';
import { StockpagemobileComponent } from './components/core/Stock Manager/stockpagemobile/stockpagemobile.component';
import { OrderpagemobileComponent } from './components/core/orders manager/orderpagemobile/orderpagemobile.component';
import { AllusersmobileComponent } from './components/core/user manager/allusersmobile/allusersmobile.component';
import { FMHomepageComponent } from './components/core/financial manager/f-m-homepage/f-m-homepage.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FMHomepagemobileComponent } from './components/core/financial manager/f-m-homepagemobile/f-m-homepagemobile.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DeliverymanagerpageComponent } from './components/core/delivery manager/deliverymanagerpage/deliverymanagerpage.component';
import { DeliverymanagerpagemobileComponent } from './components/core/delivery manager/deliverymanagerpagemobile/deliverymanagerpagemobile.component';
import { SuppliespageComponent } from './components/core/Stock Manager/suppliespage/suppliespage.component';
import { SuppliesRequestComponent } from './components/core/Stock Manager/supplies-request/supplies-request.component';
import { SupplyinvoiceComponent } from './components/core/Stock Manager/supplyinvoice/supplyinvoice.component';
import { MyclientspageComponent } from './components/core/clients manager/myclientspage/myclientspage.component';
import { MyclientspagemobileComponent } from './components/core/clients manager/myclientspagemobile/myclientspagemobile.component';
import { PointsofsaleComponent } from './components/core/Stock Manager/pointsofsale/pointsofsale.component';
import { CreatePOSComponent } from './components/core/Stock Manager/create-pos/create-pos.component';
import { AddemployeeComponent } from './components/core/Employees Manager/addemployee/addemployee.component';
import { AllemployeesComponent } from './components/core/Employees Manager/allemployees/allemployees.component';
import { EmployeeComponent } from './components/core/Employees Manager/employee/employee.component';
import { PospagemobileComponent } from './components/core/Stock Manager/mobile/pospagemobile/pospagemobile.component';
import { SuppliespagemobileComponent } from './components/core/Stock Manager/mobile/suppliespagemobile/suppliespagemobile.component';
import { EmployeepagemobileComponent } from './components/core/Employees Manager/employeepagemobile/employeepagemobile.component';
import { DailyexpensespageComponent } from './components/core/financial manager/dailyexpensespage/dailyexpensespage.component';
import { AdddeliveryheroComponent } from './components/core/delivery manager/adddeliveryhero/adddeliveryhero.component';
import { DeliveryherocollectingComponent } from './components/core/financial manager/deliveryherocollecting/deliveryherocollecting.component';
import { EmployeefingerprintComponent } from './components/core/Employees Manager/employeefingerprint/employeefingerprint.component';
import { CreatebrandComponent } from './components/core/Stock Manager/createbrand/createbrand.component';
import { AllbrandsComponent } from './components/core/Stock Manager/allbrands/allbrands.component';
import { AllbrandsmobileComponent } from './components/core/Stock Manager/mobile/allbrandsmobile/allbrandsmobile.component';
import { DeliveryordersComponent } from './components/core/orders manager/deliveryorders/deliveryorders.component';
import { ContactUsComponent } from './components/core/static pages/contact-us/contact-us.component';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { OrdercompletedComponent } from './components/core/orders manager/ordercompleted/ordercompleted.component';
import { StockpageclientsComponent } from './components/core/Stock Manager/stockpageclients/stockpageclients.component';
import { DeliveryareaspricesComponent } from './components/core/delivery manager/deliveryareasprices/deliveryareasprices.component';
import { PromocodeComponent } from './components/core/Stock Manager/e-commerce-manager/promocode/promocode.component';
import { ECommerceComponent } from './components/core/Stock Manager/e-commerce-manager/e-commerce/e-commerce.component';
import { NotificationsComponent } from './components/core/Stock Manager/e-commerce-manager/notifications/notifications.component';
// import { registerLocaleData } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PetsComponent } from './components/core/clients manager/pets/pets.component';
import { PetvaccinationsComponent } from './components/core/clients manager/petvaccinations/petvaccinations.component';
import { EmpolyeescollectingComponent } from './components/core/financial manager/empolyeescollecting/empolyeescollecting.component';
import { AddserviceComponent } from './components/core/Stock Manager/addservice/addservice.component';
import { AllservicesComponent } from './components/core/Stock Manager/allservices/allservices.component';
import { SafeUrlPipe } from './services/safe-url.pipe';
import { SalesbylocationsComponent } from './components/core/analytics/salesbylocations/salesbylocations.component';
import { AccountstatementComponent } from './components/core/clients manager/accountstatement/accountstatement.component';
import { CreateclientComponent } from './components/core/clients manager/createclient/createclient.component';
import { HerosmapviewComponent } from './components/core/delivery manager/herosmapview/herosmapview.component';
import { AddbundleComponent } from './components/core/Stock Manager/addbundle/addbundle.component';
import { AllbundlesComponent } from './components/core/Stock Manager/allbundles/allbundles.component';
import { AddorderwarehouseComponent } from './components/core/orders manager/addorderwarehouse/addorderwarehouse.component';
import { AddorderstoreComponent } from './components/core/orders manager/addorderstore/addorderstore.component';
import { StocktransferComponent } from './components/core/Stock Manager/stocktransfer/stocktransfer.component';
import { StocktransfershistroyComponent } from './components/core/Stock Manager/stocktransfershistroy/stocktransfershistroy.component';
import { TranslocoHttpLoader } from './services/translocohttploader';
import { environment } from '../environments/environment';
import { PetcompanyComponent } from './shared/headers/desktop/petcompany/petcompany.component';
import { WarehouseComponent } from './shared/headers/desktop/warehouse/warehouse.component';
import { ShopComponent } from './shared/headers/desktop/shop/shop.component';
import { ClinicComponent } from './shared/headers/desktop/clinic/clinic.component';
import { ShopandclinicComponent } from './shared/headers/desktop/shopandclinic/shopandclinic.component';
import { ShippingComponent } from './shared/headers/desktop/shipping/shipping.component';
import { PetcompanyMComponent } from './shared/headers/mobile/petcompany.m/petcompany.m.component';
import { WarehouseMComponent } from './shared/headers/mobile/warehouse.m/warehouse.m.component';
import { ShopMComponent } from './shared/headers/mobile/shop.m/shop.m.component';
import { ShopandclinicMComponent } from './shared/headers/mobile/shopandclinic.m/shopandclinic.m.component';
import { ClinicMComponent } from './shared/headers/mobile/clinic.m/clinic.m.component';
import { ShippingMComponent } from './shared/headers/mobile/shipping.m/shipping.m.component';
import { NotuserheaderComponent } from './shared/notuserheader/notuserheader.component';
import { NotuserheaderMComponent } from './shared/notuserheader.m/notuserheader.m.component';
import { MatTooltip } from "@angular/material/tooltip";
import { WarehouseinvoiceComponent } from './components/core/orders manager/invoices/warehouseinvoice/warehouseinvoice.component';
import { StoreinvoiceComponent } from './components/core/orders manager/invoices/storeinvoice/storeinvoice.component';
import { PetcompanyinvoiceComponent } from './components/core/orders manager/invoices/petcompanyinvoice/petcompanyinvoice.component';
import { WebsiteinvoiceComponent } from './components/core/orders manager/invoices/websiteinvoice/websiteinvoice.component';
import { AdddeliveryvehicleComponent } from './components/core/delivery manager/adddeliveryvehicle/adddeliveryvehicle.component';
import { ClientsbookingsComponent } from './components/core/clients manager/clientsbookings/clientsbookings.component';
import { ClientsbookingsmoblieComponent } from './components/core/clients manager/clientsbookingsmoblie/clientsbookingsmoblie.component';
import { PetsmobileComponent } from './components/core/clients manager/petsmobile/petsmobile.component';
import { PetvaccinationssmobileComponent } from './components/core/clients manager/petvaccinationssmobile/petvaccinationssmobile.component';
import { DeliveryareamobileComponent } from './components/core/delivery manager/deliveryareamobile/deliveryareamobile.component';
import { EmployeemobileComponent } from './components/core/Employees Manager/employeemobile/employeemobile.component';
import { FingerprintmobileComponent } from './components/core/Employees Manager/fingerprintmobile/fingerprintmobile.component';
import { DailyexpensesmobileComponent } from './components/core/financial manager/dailyexpensesmobile/dailyexpensesmobile.component';
import { DeliveryherocollectingmobileComponent } from './components/core/financial manager/deliveryherocollectingmobile/deliveryherocollectingmobile.component';
import { EmployeesherocollectingmobileComponent } from './components/core/financial manager/employeesherocollectingmobile/employeesherocollectingmobile.component';
import { DeliveryordersmobileComponent } from './components/core/orders manager/deliveryordersmobile/deliveryordersmobile.component';
import { AllbundlesmobileComponent } from './components/core/Stock Manager/mobile/allbundlesmobile/allbundlesmobile.component';
import { AllservicesmobileComponent } from './components/core/Stock Manager/mobile/allservicesmobile/allservicesmobile.component';
import { ECommercemobileComponent } from './components/core/Stock Manager/mobile/e-commercemobile/e-commercemobile.component';
import { NotificationsmobileComponent } from './components/core/Stock Manager/mobile/notificationsmobile/notificationsmobile.component';
import { PromocodemobileComponent } from './components/core/Stock Manager/mobile/promocodemobile/promocodemobile.component';
import { StocktransferhistorymobileComponent } from './components/core/Stock Manager/mobile/stocktransferhistorymobile/stocktransferhistorymobile.component';

import { OrdersprofitComponent } from './components/core/financial manager/ordersprofit/ordersprofit.component';
import { OrdersprofitmobileComponent } from './components/core/financial manager/ordersprofitmobile/ordersprofitmobile.component';
import { ClinicCalanderComponent } from './components/core/Stock Manager/clinic/clinic-calander/clinic-calander.component';
import { ClinicCalandermobileComponent } from './components/core/Stock Manager/clinic/clinic-calandermobile/clinic-calandermobile.component';
import { ClinicAppointmentsComponent } from './components/core/Stock Manager/clinic/clinic-appointments/clinic-appointments.component';
import { ClinicEmergencyShiftComponent } from './components/core/Stock Manager/clinic/clinic-emergency-shift/clinic-emergency-shift.component';
import { NewbookingComponent } from './components/core/clients manager/newbooking/newbooking.component';
import { CreatepetComponent } from './components/core/clients manager/createpet/createpet.component';
import { ClinicAppointmentsMobileComponent } from './components/core/Stock Manager/clinic/clinic-appointments-mobile/clinic-appointments-mobile.component';
import { BbclinicComponent } from './components/core/BB Clinic/bbclinic/bbclinic.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// registerLocaleData(localeAr);
@NgModule({
  declarations: [
    AppComponent,
    HomepageComponent,
    LoginComponent,
    AdditemComponent,
    ProfileComponent,
    ResigteringComponent,
    HeaderComponent,
    FooterComponent,
    HeaderMobileComponent,
    VerificationCodeComponent,
    LoadingComponent,
    WelcomeComponent,
    InvoiceComponent,
    NodataComponent,
    ForgetPasswordComponent,
    OrdercompletedComponent,
    ChangePasswordComponent,
    AllusersComponent,
    AddorderComponent,
    StockpageclientsComponent,
    OrderspageComponent,
    StockpagemobileComponent,
    OrderpagemobileComponent,
    AllusersmobileComponent,
    FMHomepageComponent,
    FMHomepagemobileComponent,
    DeliverymanagerpageComponent,
    DeliverymanagerpagemobileComponent,
    SuppliespageComponent,
    SuppliesRequestComponent,
    SupplyinvoiceComponent,
    MyclientspageComponent,
    MyclientspagemobileComponent,
    PointsofsaleComponent,
    CreatePOSComponent,
    AddemployeeComponent,
    AllemployeesComponent,
    EmployeeComponent,
    PospagemobileComponent,
    SuppliespagemobileComponent,
    EmployeepagemobileComponent,
    DailyexpensespageComponent,
    AdddeliveryheroComponent,
    DeliveryherocollectingComponent,
    EmployeefingerprintComponent,
    CreatebrandComponent,
    AllbrandsComponent,
    ContactUsComponent,
    AllbrandsmobileComponent,
    DeliveryordersComponent,
    DeliveryareaspricesComponent,
    PromocodeComponent,
    ECommerceComponent,
    NotificationsComponent,
    PetsComponent,
    PetvaccinationsComponent,
    EmpolyeescollectingComponent,
    AddserviceComponent,
    AllservicesComponent,
    SafeUrlPipe,
    SalesbylocationsComponent,
    AccountstatementComponent,
    CreateclientComponent,
    HerosmapviewComponent,
    AddbundleComponent,
    AllbundlesComponent,
    AddorderwarehouseComponent,
    AddorderstoreComponent,
    StocktransferComponent,
    StocktransfershistroyComponent,
    PetcompanyComponent,
    WarehouseComponent,
    ShopComponent,
    ClinicComponent,
    ShopandclinicComponent,
    ShippingComponent,
    PetcompanyMComponent,
    WarehouseMComponent,
    ShopMComponent,
    ShopandclinicMComponent,
    ClinicMComponent,
    ShippingMComponent,
    NotuserheaderComponent,
    NotuserheaderMComponent,
    WarehouseinvoiceComponent,
    StoreinvoiceComponent,
    PetcompanyinvoiceComponent,
    WebsiteinvoiceComponent,
    AdddeliveryvehicleComponent,
    ClientsbookingsComponent,
    ClientsbookingsmoblieComponent,
    PetsmobileComponent,
    PetvaccinationssmobileComponent,
    DeliveryareamobileComponent,
    EmployeemobileComponent,
    FingerprintmobileComponent,
    DailyexpensesmobileComponent,
    DeliveryherocollectingmobileComponent,
    EmployeesherocollectingmobileComponent,
    DeliveryordersmobileComponent,
    AllbundlesmobileComponent,
    AllservicesmobileComponent,
    ECommercemobileComponent,
    NotificationsmobileComponent,
    PromocodemobileComponent,
    StocktransferhistorymobileComponent,
    OrdersprofitComponent,
    OrdersprofitmobileComponent,
    ClinicCalanderComponent,
    ClinicCalandermobileComponent,
    ClinicAppointmentsComponent,
    ClinicEmergencyShiftComponent,
    NewbookingComponent,
    CreatepetComponent,
    ClinicAppointmentsMobileComponent,
    BbclinicComponent

  ],
  imports: [
    BrowserModule,
    TranslocoModule,
    MatPaginatorModule,
    AppRoutingModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,
    MatInputModule,
    BaseChartDirective,
    LazyLoadImageModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatTableModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    ZXingScannerModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    }),
    MatTooltip
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'en-US',
    },
    provideTransloco({
      config: {
        availableLangs: ['en', 'ar', 'fr'],
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    }),
    // { provide: LocationStrategy, useClass: HashLocationStrategy },
    LanguageServiceService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
